import { render, staticRenderFns } from "./CPreview.vue?vue&type=template&id=38acf3b2&scoped=true"
import script from "./CPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./CPreview.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CPreview.vue?vue&type=style&index=0&id=38acf3b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38acf3b2",
  null
  
)

export default component.exports